/* eslint-disable react-hooks/exhaustive-deps */
import CachedIcon from "@mui/icons-material/Cached";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import DownloadIcon from "@mui/icons-material/Download";
import FirstPageRoundedIcon from "@mui/icons-material/FirstPageRounded";
import LastPageRoundedIcon from "@mui/icons-material/LastPageRounded";
import {
    Button,
    Card,
    CardContent,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableFooter,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { config, ERoles, formatNumberWithComma } from "../../config";
import useAuth from "../../hooks/useAuth";
import { clearErrorMessagesForCampaignMIS, resetUpdateCampaignReportStates } from "../../redux/MISReportsManagement/misReportsSlice";
import { getActiveOrgsForResellerThunk, getMISReportsThunk, updateBillingMISReports } from "../../redux/MISReportsManagement/misReportsThunk";
import { apiGatewayAxiosInstance } from "../../utils/axios";
import TablePaginationShowPage from "../../utils/tablePagination";
import AlertMessageComponent from "../components/AlertMessageComponent";
import FetchingSpinner from "../components/FetchingSpinner";
import NoRecords from "../components/NoRecords";
import UpdateMISReportsComponent from "./UpdateMISReportsComponent";
import SearchableDropdown from "./DropDownWithSearch";
import RefreshButton from "../../utils/refreshButton";

export const calculateTime = value => {
    const time = new Date(value).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
    const day = new Date(value).toLocaleDateString([], { day: "2-digit" });
    const month = new Date(value).toLocaleDateString([], { month: "2-digit" });
    const year = new Date(value).toLocaleDateString([], { year: "numeric" });

    return (
        <Typography className="tableContentFontForDateAndTime">
            {day}-{month}-{year} <br />
            {time}
        </Typography>
    );
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 16,
        backgroundColor: theme.palette.common.lightBlue,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        border: "none",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
    },

    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    borderCollapse: "separate",
}));

const BillingMIS = () => {
    const { user } = useAuth();
    const state = useSelector(state => state.misReportsSlice);
    const now = dayjs();
    const [billingType, setBillingType] = useState("");
    const dispatch = useDispatch();
    const [executedAtStartDate, setExecutedAtStartDate] = useState(
        dayjs().startOf("month").hour(now.hour()).minute(now.minute()).second(now.second()),
    );
    const [executedAtEndDate, setExecutedAtEndDate] = useState(dayjs());
    const [searchParams, setSearchParams] = useState({
        botName: "",
        campaignName: "",
        templateName: "",
    });

    const [updateReport, setUpdateReport] = useState({
        openModel: false,
        startDate: dayjs().subtract(7, "days"),
        endDate: dayjs(),
    });

    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [timeRange, setTimeRange] = useState("Daily");

    const [reload, setReload] = useState(false);
    const [errorResponse, setErrorResponse] = useState("");
    const [selectedClient, setSelectedClient] = useState("");
    const [selectedReseller, setSelectedReseller] = useState("");
    // const [totalMISStats, setTotalMISStats] = useState({
    //     BASIC_MESSEGE: 0,
    //     A2P_SINGLE_MESSEGE: 0,
    //     A2P_CONVERSATION: 0,
    //     P2A_CONVERSATION: 0,
    //     SENT_REVOKED: 0,
    //     TRANS24: 0,
    //     SMS_DELIVERED: 0,
    //     SMS_FAILED: 0,
    // });
    const [activeReseller, setActiveReseller] = useState("");
    const [availableClients, setAvailableClients] = useState({});
    const [loadDownload, setLoadDownload] = useState(false);
    const timeRangeOptions = ["Daily", "Monthly"];

    // const getTotalMISCounts = misCounts => {
    //     if (misCounts?.length > 0) {
    //         const totalMISCounts = misCounts.reduce(
    //             (acc, item) => {
    //                 acc.BASIC_MESSEGE += item.BASIC_MESSEGE;
    //                 acc.A2P_SINGLE_MESSEGE += item.A2P_SINGLE_MESSEGE;
    //                 acc.A2P_CONVERSATION += item.A2P_CONVERSATION;
    //                 acc.P2A_CONVERSATION += item.P2A_CONVERSATION;
    //                 acc.SENT_REVOKED += item.SENT_REVOKED;
    //                 acc.TRANS24 += item.TRANS24;
    //                 acc.SMS_DELIVERED += item.SMS_DELIVERED;
    //                 acc.SMS_FAILED += item.SMS_FAILED;
    //                 return acc;
    //             },
    //             {
    //                 BASIC_MESSEGE: 0,
    //                 A2P_SINGLE_MESSEGE: 0,
    //                 A2P_CONVERSATION: 0,
    //                 P2A_CONVERSATION: 0,
    //                 SENT_REVOKED: 0,
    //                 TRANS24: 0,
    //                 SMS_DELIVERED: 0,
    //                 SMS_FAILED: 0,
    //             },
    //         );
    //         setTotalMISStats(totalMISCounts);
    //     }
    // };




    const totalMISStats = useMemo(() => {
        if (state.billingMISReports.length == 0) {
            return {
                BASIC_MESSEGE: 0,
                A2P_SINGLE_MESSEGE: 0,
                A2P_CONVERSATION: 0,
                P2A_CONVERSATION: 0,
                SENT_REVOKED: 0,
                TRANS24: 0,
                SMS_DELIVERED: 0,
                SMS_FAILED: 0,
            };

        }
        const totalMISCounts = state.billingMISReports.reduce(
            (acc, item) => {
                acc.BASIC_MESSEGE += item.BASIC_MESSEGE;
                acc.A2P_SINGLE_MESSEGE += item.A2P_SINGLE_MESSEGE;
                acc.A2P_CONVERSATION += item.A2P_CONVERSATION;
                acc.P2A_CONVERSATION += item.P2A_CONVERSATION;
                acc.SENT_REVOKED += item.SENT_REVOKED;
                acc.TRANS24 += item.TRANS24;
                acc.SMS_DELIVERED += item.SMS_DELIVERED;
                acc.SMS_FAILED += item.SMS_FAILED;
                return acc;
            },
            {
                BASIC_MESSEGE: 0,
                A2P_SINGLE_MESSEGE: 0,
                A2P_CONVERSATION: 0,
                P2A_CONVERSATION: 0,
                SENT_REVOKED: 0,
                TRANS24: 0,
                SMS_DELIVERED: 0,
                SMS_FAILED: 0,
            },
        );

        return totalMISCounts;
    }, [state.billingMISReports]);



    const handleCloseUpdateReport = () => {
        dispatch(resetUpdateCampaignReportStates());
        setUpdateReport({ ...updateReport, openModel: false });
    };

    const handleClearUpdateReport = () => {
        setUpdateReport({
            openModel: false,
            startDate: dayjs().subtract(7, "days"),
            endDate: dayjs(),
        });
    };

    const handleChangeSearchParams = event => {
        const { name, value } = event.target;
        setSearchParams({ ...searchParams, [name]: value });
    };

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setPageSize(parseInt(event.target.value));
        setCurrentPage(0);
    };

    const onCloseErrorMessage = ({ fieldName }) => {
        dispatch(clearErrorMessagesForCampaignMIS({ fieldName }));
    };

    const reloadList = () => {
        setReload(!reload);
    };

    const handleClear = () => {
        setSearchParams({
            botName: "",
            templateName: "",
        });
        setSelectedClient("All");
        setSelectedReseller("All");
        dispatch(resetUpdateCampaignReportStates());
        setExecutedAtStartDate(dayjs().startOf("month").hour(now.hour()).minute(now.minute()).second(now.second()));
        setExecutedAtEndDate(dayjs());
        setReload(!reload);
    };

    const handleUpdate = () => {
        dispatch(
            updateBillingMISReports({
                startDate: updateReport.startDate,
                endDate: updateReport.endDate,
            }),
        );
    };
    const getActiveReseller = async () => {
        try {
            if (user?.roleName !== ERoles.SUPER_ADMIN) return;
            const response = await apiGatewayAxiosInstance.get(`/user_management/reseller/get-active-reseller`);
            setActiveReseller(response.data.data);
        } catch (error) {
            console.error("Error fetching active reseller:", error);
        }
    };
    const getActiveClients = async () => {
        try {
            const response = await apiGatewayAxiosInstance.get(`/user_management/organization/get-all-active-org-by-registryId`, {
                params: {
                    registryId: selectedReseller,
                },
            });
            setAvailableClients(response.data.data);
        } catch (error) {
            console.error("Error fetching active reseller:", error);
        }
    };

    useEffect(() => {
        if (user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN) {
            // if (selectedReseller) {
            if (!selectedClient && selectedReseller) {
                getActiveClients();
            }
            const registryId = selectedReseller && selectedReseller !== "All" ? selectedReseller : null;
            const orgId = selectedClient && selectedClient !== "All" ? selectedClient : null;
            dispatch(
                getMISReportsThunk({
                    roleName: user?.roleName,
                    currentPage: currentPage + 1,
                    pageSize,
                    orgId,
                    registryId,
                    fromDate: new Date(executedAtStartDate),
                    toDate: new Date(executedAtEndDate),
                    timeRange,
                    billingType,
                }),
            );
            // } else {
            //     getActiveReseller();
            // }
        } else if (user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN) {
            dispatch(
                getMISReportsThunk({
                    roleName: user?.roleName,
                    currentPage: currentPage + 1,
                    pageSize,
                    orgId: selectedClient === "All" ? "" : selectedClient,
                    // registryId: user?.registryId,
                    fromDate: new Date(executedAtStartDate),
                    toDate: new Date(executedAtEndDate),
                    timeRange,
                }),
            );
            dispatch(getActiveOrgsForResellerThunk());
        } else {
            dispatch(
                getMISReportsThunk({
                    roleName: user?.roleName,
                    currentPage: currentPage + 1,
                    pageSize,
                    orgId: user?.orgId,
                    registryId: selectedClient === "All" ? "" : selectedClient,
                    fromDate: new Date(executedAtStartDate),
                    toDate: new Date(executedAtEndDate),
                    timeRange,
                }),
            );
        }
    }, [currentPage, pageSize, reload, selectedClient, selectedReseller, timeRange]);

    const downloadCSV = async () => {
        try {
            setLoadDownload(true);
            const response = await apiGatewayAxiosInstance.get("/mis_server/billing/download-billing-mis-report", {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                params: {
                    roleName: user?.roleName,
                    orgId: selectedClient,
                    registryId: selectedReseller,
                    fromDate: new Date(executedAtStartDate),
                    toDate: new Date(executedAtEndDate),
                    billingType,
                    timeRange
                },
            });
            if (response.status === 200) {
                const csvBlob = new Blob([response.data], {
                    type: "text/csv",
                });
                const csvUrl = URL.createObjectURL(csvBlob);

                const link = document.createElement("a");
                link.href = csvUrl;
                link.setAttribute("download", `billing_mis.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error downloading CSV: ", error);
        }
        setLoadDownload(false);
    };

    useEffect(() => {
        getActiveClients();
        getActiveReseller();

    }, []);

    // useCallback(() => {
    //     getTotalMISCounts(state.billingMISReports);

    // }, [state.billingMISReports, state.getBillingMISReportsLoading]);

    const handleChangeReseller = e => {
        const value = e.target.value;
        setCurrentPage(0);
        setPageSize(10);
        setSelectedReseller(value === "All" ? "" : value);
        if (value === "All") {
            setSelectedClient("All");
        } else {
            setSelectedClient("");
        }
    };

    return (
        <Grid>
            <Grid container mb={4} className="listHeader">
                <Grid item md={6} className="align-items-center">
                    <Typography variant="h3">
                        <b>Billing MIS</b>
                    </Typography>
                </Grid>

                <Grid item md={6} className="listHeaderFilter">
                    <Grid display={"flex"} flexDirection={"row"} gap={2}>
                        <RefreshButton loading={state.getBillingMISReportsLoading} onClick={reloadList} />
                        {user?.roleName === ERoles.SUPER_ADMIN && (
                            <Button
                                sx={{ marginRight: "10px" }}
                                variant="contained"
                                onClick={() => setUpdateReport({ ...updateReport, openModel: true })}
                            >
                                Update
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <Card className="border border-secondary-50">
                <CardContent
                    sx={{
                        padding: 0,
                    }}
                >
                    {user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
                        <Grid
                            sx={{
                                padding: 5,
                                display: "flex",
                                flexDirection: "row",
                                gap: 2,
                                "@media (max-width: 600px)": {
                                    flexDirection: "column",
                                },
                            }}
                        >
                            <SearchableDropdown
                                dropDownList={activeReseller}
                                value={selectedReseller || "All"}
                                handleChange={handleChangeReseller}
                                disabled={state.activeOrgLoading}
                                label={"Select Reseller"}
                                size="small"
                                name="Active Reseller"
                                placeholder="Reseller"
                                valueKey={"_id"}
                                dropDownValueKey={"resellerName"}
                            />

                            {config.REACT_APP_TO_SHOW_MIS_REPORTS_TO_SUPER_ADMIN === "true" && (
                                <SearchableDropdown
                                    dropDownList={availableClients}
                                    value={selectedClient || "All"}
                                    handleChange={e => {
                                        const value = e.target.value;
                                        setCurrentPage(0);
                                        setPageSize(10);
                                        setSelectedClient(value === "All" ? "" : value);
                                    }}
                                    disabled={state.activeOrgLoading || !selectedReseller}
                                    label={"Select Client"}
                                    size="small"
                                    name="Active Clients"
                                    placeholder="Clients"
                                    valueKey={"_id"}
                                    dropDownValueKey={"orgName"}
                                />
                            )}
                        </Grid>
                    )}

                    {user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN && (
                        <Grid
                            sx={{
                                padding: 5,
                                display: "flex",
                                flexDirection: "row",
                                gap: 2,
                                "@media (max-width: 600px)": {
                                    flexDirection: "column",
                                },
                            }}
                        >
                            <SearchableDropdown
                                dropDownList={state.activeOrgList}
                                value={selectedClient || "All"}
                                handleChange={e => {
                                    const value = e.target.value;
                                    setCurrentPage(0);
                                    setPageSize(10);
                                    setSelectedClient(e.target.value);
                                }}
                                disabled={state.activeOrgLoading}
                                label={"Select Client"}
                                size="small"
                                name="Active Clients"
                                placeholder="Clients"
                                valueKey={"_id"}
                                dropDownValueKey={"orgName"}
                            />
                        </Grid>
                    )}

                    <Grid
                        width={"100%"}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "row",
                            gap: 2,
                            padding: 5,
                        }}
                    >
                        <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: 5,
                                minWidth: "70%",
                            }}
                        >
                            {user?.roleName === ERoles.SUPER_ADMIN && (
                                <Grid item>
                                    <FormControl size="small" sx={{ minWidth: 150 }}>
                                        <InputLabel id="demo-simple-select-helper-label">Billing Type</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-helper-label"
                                            id="demo-simple-select-helper"
                                            name="Billing Type"
                                            value={`${billingType}`}
                                            label="Billing Type"
                                            onChange={e => setBillingType(e.target.value)}
                                        >
                                            {["Prepaid_org", "Postpaid_org", "Prepaid_reseller", "Postpaid_reseller"].map(billingType => (
                                                <MenuItem key={billingType} value={billingType}>
                                                    {billingType}
                                                </MenuItem>
                                            ))}
                                            {/* <MenuItem key={"all"} value={""}>All</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl size="small" fullWidth>
                                    <InputLabel id="reseller-label">Select Time Range</InputLabel>
                                    <Select
                                        disabled={state.activeOrgLoading}
                                        name="Time Range"
                                        labelId="time-range"
                                        id="time-range"
                                        value={timeRange}
                                        onChange={e => {
                                            const value = e.target.value;
                                            setCurrentPage(0);
                                            setPageSize(10);

                                            setTimeRange(value);
                                        }}
                                        label="Select Time Range"
                                        size="small"
                                        props={{
                                            PaperProps: {
                                                sx: {
                                                    boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                                                },
                                            },
                                        }}
                                    >
                                        {timeRangeOptions.map((option, index) => (
                                            <MenuItem key={index} value={option}>
                                                <Typography sx={{ fontSize: "0.9rem", fontWeight: "400" }}>{option}</Typography>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Start Date"
                                        value={executedAtStartDate}
                                        onChange={value => setExecutedAtStartDate(dayjs(value))}
                                        format="DD-MM-YYYY"
                                        name="startDate"
                                        disableFuture
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "36px",
                                                padding: "0 10px",
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="End Date"
                                        value={executedAtEndDate}
                                        onChange={value => setExecutedAtEndDate(dayjs(value))}
                                        format="DD-MM-YYYY"
                                        name="startDate"
                                        disableFuture
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "36px",
                                                padding: "0 10px",
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>

                        <Grid
                            minWidth={"30%"}
                            sx={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <Button
                                onClick={handleClear}
                                color="error"
                                variant="contained"
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: 1,
                                    padding: "6px 16px",
                                }}
                            >
                                Clear
                            </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: 1,
                                    padding: "6px 16px", // Adjust button padding
                                }}
                                onClick={() => {
                                    setCurrentPage(0);
                                    setReload(!reload);
                                }}
                            >
                                Search
                            </Button>

                            <Button onClick={downloadCSV} disabled={loadDownload || state?.billingMISReports?.length <= 0}>
                                {loadDownload ? <CircularProgress size={15} className="spinner" /> : <DownloadIcon />}
                                &nbsp; Download Report
                            </Button>
                        </Grid>
                    </Grid>
                    <>
                        {state.getBillingMISReportsLoading ? (
                            <FetchingSpinner />
                        ) : state.billingMISReports && state?.billingMISReports?.length > 0 ? (
                            <StyledTableContainer component={Paper} className="table-container" sx={{ maxHeight: "70vh" }}>
                                <Table size="small" stickyHeader aria-label="simple table">
                                    <TableHead className="p-3 mb-2 row">
                                        <TableRow>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>Sr No</Typography>
                                            </StyledTableCell>

                                            {user?.roleName === ERoles.SUPER_ADMIN && (
                                                // {!selectedReseller && !(user?.roleName === ERoles.ORG_ADMIN) && (
                                                <StyledTableCell align="left" className="col-1 tableHeaderFont">
                                                    <Typography>Reseller Name</Typography>
                                                </StyledTableCell>
                                            )}
                                            {!(user?.roleName === ERoles.ORG_ADMIN) && (
                                                <StyledTableCell align="left" className="col-1 tableHeaderFont">
                                                    <Typography>Organization Name</Typography>
                                                </StyledTableCell>
                                            )}

                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>Date</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>Basic Message</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>A2P Single Message</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>A2P Conversation</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>P2A Conversation</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>Sent Revoked</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>Trans 24</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>SMS Delivered</Typography>
                                            </StyledTableCell>
                                            <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                <Typography>SMS Failed</Typography>
                                            </StyledTableCell>
                                            {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
                                                (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
                                                    user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
                                                    <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                        <Typography>Billing Customer Name</Typography>
                                                    </StyledTableCell>
                                                )}

                                            {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
                                                (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
                                                    user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
                                                    <StyledTableCell align="center" className="col-1 tableHeaderFont">
                                                        <Typography>Billing Type</Typography>
                                                    </StyledTableCell>
                                                )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state.billingMISReports.map((data, index) => (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell align="center">{currentPage * pageSize + index + 1}</StyledTableCell>

                                                {user?.roleName === ERoles.SUPER_ADMIN && (
                                                    <StyledTableCell align="left">{data.resellerName}</StyledTableCell>
                                                )}
                                                {!(user?.roleName === ERoles.ORG_ADMIN) && (
                                                    <StyledTableCell align="left">{data.orgName}</StyledTableCell>
                                                )}

                                                <StyledTableCell align="center">
                                                    {timeRange === "Monthly" ? (
                                                        <>
                                                            <Typography className="tableContentFontForDateAndTime">
                                                                {data.monthName} {data.year}
                                                            </Typography>
                                                        </>
                                                    ) : (
                                                        <Typography className="tableContentFontForDateAndTime">
                                                            {new Date(data.executedAt).toLocaleDateString([], { day: "2-digit" })}-
                                                            {new Date(data.executedAt).toLocaleDateString([], { month: "2-digit" })}-
                                                            {new Date(data.executedAt).toLocaleDateString([], { year: "numeric" })}
                                                        </Typography>
                                                    )}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.BASIC_MESSEGE)}</StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.A2P_SINGLE_MESSEGE)}</StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.A2P_CONVERSATION)}</StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.P2A_CONVERSATION)}</StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.SENT_REVOKED)}</StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.TRANS24)}</StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.SMS_DELIVERED)}</StyledTableCell>
                                                <StyledTableCell align="center">{formatNumberWithComma(data.SMS_FAILED)}</StyledTableCell>

                                                {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
                                                    (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
                                                        user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
                                                        <StyledTableCell align="center">
                                                            {data?.billingCustomerName ? data.billingCustomerName : "-"}
                                                        </StyledTableCell>
                                                    )}

                                                {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
                                                    (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
                                                        user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
                                                        <StyledTableCell align="center">{data?.billingType ? data.billingType : "-"}</StyledTableCell>
                                                    )}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>

                                    {totalMISStats && (
                                        <TableFooter
                                            className="sticky-footer"
                                            sx={{
                                                position: "sticky",
                                                bottom: 0,
                                                backgroundColor: "red",
                                                padding: 0,
                                                margin: 0,
                                            }}
                                        >
                                            <StyledTableRow>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {"Total: "}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center"></StyledTableCell>
                                                {user?.roleName === ERoles.SUPER_ADMIN && (
                                                    <StyledTableCell className="tableHeaderFont" align="center"></StyledTableCell>
                                                )}
                                                {!(user?.roleName === ERoles.ORG_ADMIN) && (
                                                    <StyledTableCell className="tableHeaderFont" align="center"></StyledTableCell>
                                                )}
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.BASIC_MESSEGE)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.A2P_SINGLE_MESSEGE)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.A2P_CONVERSATION)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.P2A_CONVERSATION)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.SENT_REVOKED)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.TRANS24)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.SMS_DELIVERED)}
                                                </StyledTableCell>
                                                <StyledTableCell className="tableHeaderFont" align="center">
                                                    {formatNumberWithComma(totalMISStats.SMS_FAILED)}
                                                </StyledTableCell>
                                                {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
                                                    (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
                                                        user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
                                                        <StyledTableCell className="tableHeaderFont" align="center"></StyledTableCell>
                                                    )}
                                                {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
                                                    (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
                                                        user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
                                                        <StyledTableCell className="tableHeaderFont" align="center"></StyledTableCell>
                                                    )}{" "}
                                            </StyledTableRow>
                                        </TableFooter>
                                    )}
                                </Table>
                            </StyledTableContainer>
                        ) : (
                            <NoRecords />
                        )}

                        {/* <StyledTableCell className="tableHeaderFont" align="center">
                            {formatNumberWithComma(totalMISStats.BASIC_MESSEGE)}
                        </StyledTableCell>
                        <StyledTableCell className="tableHeaderFont" align="center">
                            {formatNumberWithComma(totalMISStats.A2P_SINGLE_MESSEGE)}
                        </StyledTableCell> */}

                        {/* TOTAL:   {totalMISStats.BASIC_MESSEGE + totalMISStats.A2P_SINGLE_MESSEGE - totalMISStats.SENT_REVOKED} */}
                        {state.billingMISReportsCount > 0 && (
                            <Grid
                                className="my-2"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: 10,
                                }}
                            >
                                <Grid
                                    style={{
                                        marginTop: "15px",
                                    }}
                                >
                                    Total Billing Reports: {state.billingMISReportsCount}
                                </Grid>

                                <TablePaginationShowPage
                                    rowsPerPageOptions={[5, 10, 25, 100, 500, 1000]}
                                    colSpan={3}
                                    count={state.billingMISReportsCount}
                                    rowsPerPage={pageSize}
                                    page={currentPage}
                                    slotProps={{
                                        select: {
                                            "aria-label": "Rows per page",
                                        },
                                        actions: {
                                            showFirstButton: true,
                                            showLastButton: true,
                                            slots: {
                                                firstPageIcon: FirstPageRoundedIcon,
                                                lastPageIcon: LastPageRoundedIcon,
                                                nextPageIcon: ChevronRightRoundedIcon,
                                                backPageIcon: ChevronLeftRoundedIcon,
                                            },
                                        },
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                                <AlertMessageComponent
                                    message={errorResponse}
                                    fieldName={"ErrorMessage"}
                                    handleClose={() => setErrorResponse("")}
                                    show={Boolean(errorResponse)}
                                />
                            </Grid>
                        )}
                    </>

                    {updateReport.openModel && (
                        <UpdateMISReportsComponent
                            open={updateReport.openModel}
                            handleClose={handleCloseUpdateReport}
                            setUpdateDates={setUpdateReport}
                            updateDates={updateReport}
                            handleClear={handleClearUpdateReport}
                            handleUpdate={handleUpdate}
                            loading={state.updateBillingMISReportsLoading}
                            error={state.updateBillingMISReportsError}
                            success={state.updateBillingMISReports}
                        />
                    )}
                    {state.getCampaignMISReportsError && (
                        <AlertMessageComponent
                            message={state.getCampaignMISReportsError}
                            fieldName={"getCampaignMISReportsError"}
                            handleClose={onCloseErrorMessage}
                            show={Boolean(state.getCampaignMISReportsError)}
                        />
                    )}
                </CardContent>
            </Card>
        </Grid>
    );

    // return (
    //     <Grid>
    //         <Grid container mb={4} className='listHeader'>
    //             <Grid item md={6} className='align-items-center'>
    //                 <Typography variant='h3'>
    //                     <b>Billing MIS</b>
    //                 </Typography>
    //             </Grid>

    //             <Grid item md={6} className='listHeaderFilter'>
    //                 <Grid display={"flex"} flexDirection={"row"} gap={2}>
    //                     <IconButton
    //                         title='Refresh'
    //                         onClick={reloadList}
    //                         sx={{
    //                             animation: state.getBillingMISReportsLoading ? "spin 0.5s linear infinite" : "",
    //                             "@keyframes spin": {
    //                                 "0%": {
    //                                     transform: "rotate(360deg)",
    //                                 },
    //                                 "100%": {
    //                                     transform: "rotate(0deg)",
    //                                 },
    //                             },
    //                         }}
    //                     >
    //                         <CachedIcon />
    //                     </IconButton>
    //                     {user?.roleName === ERoles.SUPER_ADMIN && (
    //                         <Button
    //                             sx={{ marginRight: "10px" }}
    //                             variant='contained'
    //                             onClick={() => setUpdateReport({ ...updateReport, openModel: true })}
    //                         >
    //                             Update
    //                         </Button>
    //                     )}
    //                 </Grid>
    //             </Grid>
    //         </Grid>
    //         <Card className='border border-secondary-50'>
    //             <CardContent
    //                 sx={{
    //                     padding: 0,
    //                 }}
    //             >
    //                 {user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN && (
    //                     <Grid
    //                         sx={{
    //                             padding: 5,
    //                             display: "flex",
    //                             flexDirection: "row",
    //                             gap: 2,
    //                             "@media (max-width: 600px)": {
    //                                 flexDirection: "column",
    //                             },
    //                         }}
    //                     >
    //                         <FormControl size='small' fullWidth>
    //                             <InputLabel id='client-label'>Select Client</InputLabel>
    //                             <Select
    //                                 disabled={state.activeOrgLoading}
    //                                 name='Active Clients'
    //                                 labelId='client-label'
    //                                 id='client-label'
    //                                 value={selectedClient}
    //                                 onChange={e => {
    //                                     setCurrentPage(0);
    //                                     setPageSize(10);
    //                                     setSelectedClient(e.target.value);
    //                                 }}
    //                                 label='Select Client'
    //                                 size='small'
    //                                 props={{
    //                                     PaperProps: {
    //                                         sx: {
    //                                             boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    //                                         },
    //                                     },
    //                                 }}
    //                             >
    //                                 {state.activeOrgList &&
    //                                     state.activeOrgList?.length > 0 &&
    //                                     state.activeOrgList?.map((org, index) => (
    //                                         <MenuItem key={index} value={org._id}>
    //                                             <Grid
    //                                                 container
    //                                                 sx={{
    //                                                     display: "flex",
    //                                                     alignItems: "center",
    //                                                     justifyContent: "space-between",
    //                                                 }}
    //                                             >
    //                                                 <Grid item md={6} display={"flex"} flexDirection={"column"}>
    //                                                     <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>{org?.orgName}</Typography>
    //                                                 </Grid>
    //                                             </Grid>
    //                                         </MenuItem>
    //                                     ))}
    //                             </Select>
    //                         </FormControl>

    //                         <FormControl size='small' fullWidth>
    //                             <InputLabel id='reseller-label'>Select Time Range</InputLabel>
    //                             <Select
    //                                 disabled={state.activeOrgLoading}
    //                                 name='Time Range'
    //                                 labelId='time-range'
    //                                 id='time-range'
    //                                 value={timeRange}
    //                                 onChange={e => {
    //                                     const value = e.target.value;
    //                                     setCurrentPage(0);
    //                                     setPageSize(10);
    //                                     // setSelectedReseller(e.target.value);
    //                                     // setSelectedReseller(value === "Daily" ? "" : value);
    //                                     setTimeRange(value);
    //                                     // if (value === "Daily") {
    //                                     //     setSelectedClient("Daily");
    //                                     // } else {
    //                                     //     setSelectedClient("");
    //                                     // }
    //                                 }}
    //                                 label='Select Time Range'
    //                                 size='small'
    //                                 props={{
    //                                     PaperProps: {
    //                                         sx: {
    //                                             boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    //                                         },
    //                                     },
    //                                 }}
    //                             >
    //                                 {timeRangeOptions.map((option, index) => (
    //                                     <MenuItem key={index} value={option}>
    //                                         <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>{option}</Typography>
    //                                     </MenuItem>
    //                                 ))}
    //                             </Select>
    //                         </FormControl>
    //                     </Grid>
    //                 )}

    //                 {user?.roleName.toLowerCase() === ERoles.SUPER_ADMIN && (
    //                     <Grid
    //                         sx={{
    //                             padding: 5,
    //                             display: "flex",
    //                             flexDirection: "row",
    //                             gap: 2,
    //                             "@media (max-width: 600px)": {
    //                                 flexDirection: "column",
    //                             },
    //                         }}
    //                     >
    //                         <FormControl size='small' fullWidth>
    //                             <InputLabel id='reseller-label'>Select Reseller</InputLabel>
    //                             <Select
    //                                 disabled={state.activeOrgLoading}
    //                                 name='Active Reseller'
    //                                 labelId='client-label'
    //                                 id='client-label'
    //                                 value={selectedReseller || "All"}
    //                                 onChange={e => {
    //                                     const value = e.target.value;
    //                                     setCurrentPage(0);
    //                                     setPageSize(10);
    //                                     // setSelectedReseller(e.target.value);
    //                                     setSelectedReseller(value === "All" ? "" : value);
    //                                     if (value === "All") {
    //                                         setSelectedClient("All");
    //                                     } else {
    //                                         setSelectedClient("");
    //                                     }
    //                                 }}
    //                                 label='Select Reseller'
    //                                 size='small'
    //                                 props={{
    //                                     PaperProps: {
    //                                         sx: {
    //                                             boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    //                                         },
    //                                     },
    //                                 }}
    //                             >
    //                                 <MenuItem value='All'>
    //                                     <Grid
    //                                         container
    //                                         sx={{
    //                                             display: "flex",
    //                                             alignItems: "center",
    //                                             justifyContent: "space-between",
    //                                         }}
    //                                     >
    //                                         <Grid item md={6} display={"flex"} flexDirection={"column"}>
    //                                             <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>All</Typography>
    //                                         </Grid>
    //                                     </Grid>
    //                                 </MenuItem>
    //                                 {activeReseller &&
    //                                     activeReseller?.length > 0 &&
    //                                     activeReseller?.map((reseller, index) => (
    //                                         <MenuItem key={index} value={reseller._id}>
    //                                             <Grid
    //                                                 container
    //                                                 sx={{
    //                                                     display: "flex",
    //                                                     alignItems: "center",
    //                                                     justifyContent: "space-between",
    //                                                 }}
    //                                             >
    //                                                 <Grid item md={6} display={"flex"} flexDirection={"column"}>
    //                                                     <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>
    //                                                         {reseller?.resellerName}
    //                                                     </Typography>
    //                                                 </Grid>
    //                                             </Grid>
    //                                         </MenuItem>
    //                                     ))}
    //                             </Select>
    //                         </FormControl>

    //                         {config.REACT_APP_TO_SHOW_MIS_REPORTS_TO_SUPER_ADMIN === "true" && (
    //                             <FormControl size='small' fullWidth>
    //                                 <InputLabel id='client-label'>Select Client </InputLabel>
    //                                 <Select
    //                                     disabled={state.activeOrgLoading || !selectedReseller}
    //                                     name='Active Clients'
    //                                     labelId='client-label'
    //                                     id='client-label'
    //                                     value={selectedClient || "All"}
    //                                     onChange={e => {
    //                                         const value = e.target.value;
    //                                         setCurrentPage(0);
    //                                         setPageSize(10);
    //                                         setSelectedClient(value === "All" ? "" : value);
    //                                     }}
    //                                     label='Select Client'
    //                                     size='small'
    //                                     props={{
    //                                         PaperProps: {
    //                                             sx: {
    //                                                 boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    //                                             },
    //                                         },
    //                                     }}
    //                                 >
    //                                     <MenuItem value='All'>
    //                                         <Grid
    //                                             container
    //                                             sx={{
    //                                                 display: "flex",
    //                                                 alignItems: "center",
    //                                                 justifyContent: "space-between",
    //                                             }}
    //                                         >
    //                                             <Grid item md={6} display={"flex"} flexDirection={"column"}>
    //                                                 <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>All</Typography>
    //                                             </Grid>
    //                                         </Grid>
    //                                     </MenuItem>
    //                                     {availableClients &&
    //                                         availableClients?.length > 0 &&
    //                                         availableClients?.map((org, index) => (
    //                                             <MenuItem key={index} value={org._id}>
    //                                                 <Grid
    //                                                     container
    //                                                     sx={{
    //                                                         display: "flex",
    //                                                         alignItems: "center",
    //                                                         justifyContent: "space-between",
    //                                                     }}
    //                                                 >
    //                                                     <Grid item md={6} display={"flex"} flexDirection={"column"}>
    //                                                         <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>{org?.orgName}</Typography>
    //                                                     </Grid>
    //                                                 </Grid>
    //                                             </MenuItem>
    //                                         ))}
    //                                 </Select>
    //                             </FormControl>
    //                         )}

    //                         <FormControl size='small' fullWidth>
    //                             <InputLabel id='reseller-label'>Select Time Range</InputLabel>
    //                             <Select
    //                                 disabled={state.activeOrgLoading}
    //                                 name='Time Range'
    //                                 labelId='time-range'
    //                                 id='time-range'
    //                                 value={timeRange}
    //                                 onChange={e => {
    //                                     const value = e.target.value;
    //                                     setCurrentPage(0);
    //                                     setPageSize(10);
    //                                     // setSelectedReseller(e.target.value);
    //                                     // setSelectedReseller(value === "Daily" ? "" : value);
    //                                     setTimeRange(value);
    //                                     // if (value === "Daily") {
    //                                     //     setSelectedClient("Daily");
    //                                     // } else {
    //                                     //     setSelectedClient("");
    //                                     // }
    //                                 }}
    //                                 label='Select Time Range'
    //                                 size='small'
    //                                 props={{
    //                                     PaperProps: {
    //                                         sx: {
    //                                             boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    //                                         },
    //                                     },
    //                                 }}
    //                             >
    //                                 {timeRangeOptions.map((option, index) => (
    //                                     <MenuItem key={index} value={option}>
    //                                         <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>{option}</Typography>
    //                                     </MenuItem>
    //                                 ))}
    //                             </Select>
    //                         </FormControl>
    //                     </Grid>
    //                 )}

    //                 {user?.roleName.toLowerCase() === ERoles.RESELLER_ADMIN && !selectedClient ? (
    //                     <Typography color='black' fontWeight={500} textAlign={"center"}>
    //                         Select Client
    //                     </Typography>
    //                 ) : (
    //                     <>
    //                         {user?.roleName.toLowerCase() === ERoles.ORG_ADMIN && (
    //                             <Grid
    //                                 sx={{
    //                                     padding: 5,
    //                                     display: "flex",
    //                                     flexDirection: "row",
    //                                     gap: 2,
    //                                     "@media (max-width: 600px)": {
    //                                         flexDirection: "column",
    //                                     },
    //                                 }}
    //                             >
    //                                 <FormControl size='small' fullWidth>
    //                                     <InputLabel id='reseller-label'>Select Time Range</InputLabel>
    //                                     <Select
    //                                         disabled={state.activeOrgLoading}
    //                                         name='Time Range'
    //                                         labelId='time-range'
    //                                         id='time-range'
    //                                         value={timeRange}
    //                                         onChange={e => {
    //                                             const value = e.target.value;
    //                                             setCurrentPage(0);
    //                                             setPageSize(10);
    //                                             // setSelectedReseller(e.target.value);
    //                                             // setSelectedReseller(value === "Daily" ? "" : value);
    //                                             setTimeRange(value);
    //                                             // if (value === "Daily") {
    //                                             //     setSelectedClient("Daily");
    //                                             // } else {
    //                                             //     setSelectedClient("");
    //                                             // }
    //                                         }}
    //                                         label='Select Reseller'
    //                                         size='small'
    //                                         props={{
    //                                             PaperProps: {
    //                                                 sx: {
    //                                                     boxShadow: " 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    //                                                 },
    //                                             },
    //                                         }}
    //                                     >
    //                                         {timeRangeOptions.map((option, index) => (
    //                                             <MenuItem key={index} value={option}>
    //                                                 <Typography sx={{ fontSize: "0.9rem", fontWeight: "600" }}>{option}</Typography>
    //                                             </MenuItem>
    //                                         ))}
    //                                     </Select>
    //                                 </FormControl>
    //                             </Grid>
    //                         )}
    //                         <Grid
    //                             sx={{
    //                                 display: "flex",
    //                                 justifyContent: "space-between",
    //                                 flexDirection: "row",
    //                                 gap: 2,
    //                                 padding: 5,
    //                             }}
    //                         >
    //                             <Grid
    //                                 sx={{
    //                                     display: "flex",
    //                                     flexDirection: "row",
    //                                     gap: 5,
    //                                 }}
    //                             >
    //                                 <Grid>
    //                                     <LocalizationProvider dateAdapter={AdapterDayjs}>
    //                                         <DatePicker
    //                                             label='Start Date'
    //                                             value={executedAtStartDate}
    //                                             onChange={value => setExecutedAtStartDate(dayjs(value))}
    //                                             format='DD-MM-YYYY'
    //                                             name='startDate'
    //                                             disableFuture
    //                                             sx={{
    //                                                 "& .MuiInputBase-root": {
    //                                                     height: "36px",
    //                                                     padding: "0 10px",
    //                                                 },
    //                                             }}
    //                                         />
    //                                     </LocalizationProvider>
    //                                 </Grid>
    //                                 <Grid>
    //                                     <LocalizationProvider dateAdapter={AdapterDayjs}>
    //                                         <DatePicker
    //                                             label='End Date'
    //                                             value={executedAtEndDate}
    //                                             onChange={value => setExecutedAtEndDate(dayjs(value))}
    //                                             format='DD-MM-YYYY'
    //                                             name='startDate'
    //                                             disableFuture
    //                                             sx={{
    //                                                 "& .MuiInputBase-root": {
    //                                                     height: "36px",
    //                                                     padding: "0 10px",
    //                                                 },
    //                                             }}
    //                                         />
    //                                     </LocalizationProvider>
    //                                 </Grid>
    //                             </Grid>
    //                             <Grid
    //                                 sx={{
    //                                     display: "flex",
    //                                     justifyContent: "center",
    //                                     alignItems: "center",
    //                                     gap: 2,
    //                                 }}
    //                             >
    //                                 <Button
    //                                     onClick={handleClear}
    //                                     color='error'
    //                                     variant='contained'
    //                                     sx={{
    //                                         display: "flex",
    //                                         justifyContent: "center",
    //                                         alignItems: "center",
    //                                         gap: 1,
    //                                         padding: "6px 16px",
    //                                     }}
    //                                 >
    //                                     Clear
    //                                 </Button>
    //                                 <Button
    //                                     color='primary'
    //                                     variant='contained'
    //                                     sx={{
    //                                         display: "flex",
    //                                         justifyContent: "center",
    //                                         alignItems: "center",
    //                                         gap: 1,
    //                                         padding: "6px 16px", // Adjust button padding
    //                                     }}
    //                                     onClick={() => setReload(!reload)}
    //                                 >
    //                                     Search
    //                                 </Button>

    //                                 {/* <Button
    //                                     sx={{
    //                                         display: "flex",
    //                                         justifyContent: "center",
    //                                         alignItems: "center",
    //                                         gap: 1,
    //                                         padding: "6px 16px",
    //                                     }}
    //                                     variant="contained"
    //                                     color="primary"
    //                                     size="small"
    //                                     startIcon={<Search />}
    //                                     onClick={downloadCSV}
    //                                 >
    //                                     Download CSV
    //                                 </Button> */}

    //                                 <Button onClick={downloadCSV} disabled={loadDownload || state?.billingMISReports?.length <= 0}>
    //                                     {loadDownload ? <CircularProgress size={15} className='spinner' /> : <DownloadIcon />}
    //                                     &nbsp; Download Report
    //                                 </Button>
    //                             </Grid>
    //                         </Grid>

    //                         <>
    //                             {state.getBillingMISReportsLoading ? (
    //                                 <FetchingSpinner />
    //                             ) : state.billingMISReports && state?.billingMISReports?.length > 0 ? (
    //                                 <StyledTableContainer component={Paper} className='table-container' sx={{ maxHeight: "70vh" }}>
    //                                     <Table stickyHeader aria-label='simple table'>
    //                                         <TableHead className='p-3 mb-2 row'>
    //                                             <TableRow>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>Sr No</Typography>
    //                                                 </StyledTableCell>
    //                                                 {(!selectedClient || selectedClient === "All") && !(user?.roleName === ERoles.ORG_ADMIN) && (
    //                                                     <StyledTableCell align='left' className='col-1 tableHeaderFont'>
    //                                                         <Typography fontSize={14}>Organization Name</Typography>
    //                                                     </StyledTableCell>
    //                                                 )}
    //                                                 {user?.roleName === ERoles.SUPER_ADMIN && !selectedReseller && (
    //                                                     // {!selectedReseller && !(user?.roleName === ERoles.ORG_ADMIN) && (
    //                                                     <StyledTableCell align='left' className='col-1 tableHeaderFont'>
    //                                                         <Typography fontSize={14}>Reseller Name</Typography>
    //                                                     </StyledTableCell>
    //                                                 )}
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>Date</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>Basic Message</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>A2P Single Message</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>A2P Conversation</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>P2A Conversation</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>Sent Revoked</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>Trans 24</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>SMS Delivered</Typography>
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                     <Typography fontSize={14}>SMS Failed</Typography>
    //                                                 </StyledTableCell>
    //                                                 {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
    //                                                     (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
    //                                                         user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
    //                                                         <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                             <Typography fontSize={14}>Billing Customer Name</Typography>
    //                                                         </StyledTableCell>
    //                                                     )}

    //                                                 {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
    //                                                     (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
    //                                                         user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
    //                                                         <StyledTableCell align='center' className='col-1 tableHeaderFont'>
    //                                                             <Typography fontSize={14}>Billing Type</Typography>
    //                                                         </StyledTableCell>
    //                                                     )}
    //                                             </TableRow>
    //                                         </TableHead>
    //                                         <TableBody>
    //                                             {user &&
    //                                                 user?.roleName === ERoles.RESELLER_ADMIN &&
    //                                                 selectedClient &&
    //                                                 state.billingMISReports.map((data, index) => (
    //                                                     <StyledTableRow key={index}>
    //                                                         <StyledTableCell  align='center'>
    //                                                             <b>{currentPage * pageSize + index + 1}</b>
    //                                                         </StyledTableCell>
    //                                                         {/* {!selectedClient && (
    //                                                             <StyledTableCell className="tableContentFont" align="center">
    //                                                                 <b>{data.orgName}</b>
    //                                                             </StyledTableCell>
    //                                                         )} */}

    //                                                         {/* {!selectedReseller && (

    //                                                             <StyledTableCell className="tableContentFont" align="left">
    //                                                                 {data.resellerName}
    //                                                             </StyledTableCell>
    //                                                         )} */}
    //                                                         <StyledTableCell align='center'>
    //                                                             {timeRange === "Monthly" ? (
    //                                                                 <>
    //                                                                     <Typography className='tableContentFontForDateAndTime'>
    //                                                                         {data.monthName} {data.year}
    //                                                                     </Typography>
    //                                                                 </>
    //                                                             ) : (
    //                                                                 <Typography className='tableContentFontForDateAndTime'>
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { day: "2-digit" })}-
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { month: "2-digit" })}-
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { year: "numeric" })}
    //                                                                 </Typography>
    //                                                             )}
    //                                                         </StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.BASIC_MESSEGE)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.A2P_SINGLE_MESSEGE)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.A2P_CONVERSATION)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.P2A_CONVERSATION)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SENT_REVOKED)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.TRANS24)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SMS_DELIVERED)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SMS_FAILED)}</StyledTableCell>
    //                                                         {user?.registryId && user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID && (
    //                                                             <StyledTableCell align='center'>
    //                                                                 {data?.billingCustomerType ? data.billingCustomerType : "-"}
    //                                                             </StyledTableCell>
    //                                                         )}
    //                                                         {user?.registryId && user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID && (
    //                                                             <StyledTableCell align='center'>
    //                                                                 {data?.billingType ? data.billingType : "-"}
    //                                                             </StyledTableCell>
    //                                                         )}
    //                                                     </StyledTableRow>
    //                                                 ))}

    //                                             {user &&
    //                                                 user?.roleName === ERoles.SUPER_ADMIN &&
    //                                                 activeReseller &&
    //                                                 state.billingMISReports.map((data, index) => (
    //                                                     <StyledTableRow key={index}>
    //                                                         <StyledTableCell  align='center'>
    //                                                             <b>{currentPage * pageSize + index + 1}</b>
    //                                                         </StyledTableCell>
    //                                                         {(!selectedClient || selectedClient === "All") && !(user?.roleName === ERoles.ORG_ADMIN) && (
    //                                                             <StyledTableCell  align='left'>
    //                                                                 <b>{data.orgName}</b>
    //                                                             </StyledTableCell>
    //                                                         )}

    //                                                         {!selectedReseller && (
    //                                                             <StyledTableCell  align='left'>
    //                                                                 <b>{data.resellerName}</b>
    //                                                             </StyledTableCell>
    //                                                         )}
    //                                                         <StyledTableCell align='center'>
    //                                                             {timeRange === "Monthly" ? (
    //                                                                 <>
    //                                                                     <Typography className='tableContentFontForDateAndTime'>
    //                                                                         {data.monthName} {data.year}
    //                                                                     </Typography>
    //                                                                 </>
    //                                                             ) : (
    //                                                                 <Typography className='tableContentFontForDateAndTime'>
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { day: "2-digit" })}-
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { month: "2-digit" })}-
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { year: "numeric" })}
    //                                                                 </Typography>
    //                                                             )}
    //                                                         </StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.BASIC_MESSEGE)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.A2P_SINGLE_MESSEGE)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.A2P_CONVERSATION)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.P2A_CONVERSATION)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SENT_REVOKED)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.TRANS24)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SMS_DELIVERED)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SMS_FAILED)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>
    //                                                             {data?.billingCustomerType ? data.billingCustomerType : "-"}
    //                                                         </StyledTableCell>
    //                                                         <StyledTableCell align='center'>
    //                                                             {data?.billingType ? data.billingType : "-"}
    //                                                         </StyledTableCell>
    //                                                     </StyledTableRow>
    //                                                 ))}

    //                                             {user &&
    //                                                 user?.roleName === ERoles.ORG_ADMIN &&
    //                                                 state.billingMISReports.map((data, index) => (
    //                                                     <StyledTableRow key={index}>
    //                                                         <StyledTableCell  align='center'>
    //                                                             <b>{currentPage * pageSize + index + 1}</b>
    //                                                         </StyledTableCell>
    //                                                         {/* <StyledTableCell className="tableContentFont" align="center">
    //                                                             <b>{data.resellerName}</b>
    //                                                         </StyledTableCell> */}
    //                                                         <StyledTableCell align='center'>
    //                                                             {timeRange === "Monthly" ? (
    //                                                                 <>
    //                                                                     <Typography className='tableContentFontForDateAndTime'>
    //                                                                         {data.monthName} {data.year}
    //                                                                     </Typography>
    //                                                                 </>
    //                                                             ) : (
    //                                                                 <Typography className='tableContentFontForDateAndTime'>
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { day: "2-digit" })}-
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { month: "2-digit" })}-
    //                                                                     {new Date(data.executedAt).toLocaleDateString([], { year: "numeric" })}
    //                                                                 </Typography>
    //                                                             )}
    //                                                         </StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.BASIC_MESSEGE)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.A2P_SINGLE_MESSEGE)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.A2P_CONVERSATION)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.P2A_CONVERSATION)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SENT_REVOKED)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.TRANS24)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SMS_DELIVERED)}</StyledTableCell>
    //                                                         <StyledTableCell align='center'>{formatNumberWithComma(data.SMS_FAILED)}</StyledTableCell>
    //                                                     </StyledTableRow>
    //                                                 ))}
    //                                         </TableBody>
    //                                         <TableFooter
    //                                             className='sticky-footer'
    //                                             sx={{
    //                                                 position: "sticky",
    //                                                 bottom: 0,
    //                                                 backgroundColor: "red",
    //                                                 padding: 0,
    //                                                 margin: 0,
    //                                             }}
    //                                         >
    //                                             <StyledTableRow>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {"Total: "}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'></StyledTableCell>
    //                                                 {user?.roleName === ERoles.SUPER_ADMIN && !selectedReseller && (
    //                                                     // {!selectedReseller && !(user?.roleName === ERoles.ORG_ADMIN) && (

    //                                                     <StyledTableCell className='tableHeaderFont' align='center'></StyledTableCell>
    //                                                 )}
    //                                                 {(!selectedClient || selectedClient === "All") && !(user?.roleName === ERoles.ORG_ADMIN) && (
    //                                                     <StyledTableCell className='tableHeaderFont' align='center'></StyledTableCell>
    //                                                 )}
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.BASIC_MESSEGE)}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.A2P_SINGLE_MESSEGE)}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.A2P_CONVERSATION)}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.P2A_CONVERSATION)}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.SENT_REVOKED)}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.TRANS24)}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.SMS_DELIVERED)}
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell className='tableHeaderFont' align='center'>
    //                                                     {formatNumberWithComma(totalMISStats.SMS_FAILED)}
    //                                                 </StyledTableCell>
    //                                                 {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
    //                                                     (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
    //                                                         user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
    //                                                         <StyledTableCell className='tableHeaderFont' align='center'></StyledTableCell>
    //                                                     )}
    //                                                 {(user?.roleName === ERoles.SUPER_ADMIN || // branch 1
    //                                                     (user?.roleName === ERoles.RESELLER_ADMIN && // branch 2
    //                                                         user?.registryId === config.REACT_APP_PINNACLE_RESELLER_ID)) && (
    //                                                         <StyledTableCell className='tableHeaderFont' align='center'></StyledTableCell>
    //                                                     )}{" "}
    //                                             </StyledTableRow>
    //                                         </TableFooter>
    //                                     </Table>
    //                                 </StyledTableContainer>
    //                             ) : (
    //                                 <NoRecords />
    //                             )}

    //                             {state.billingMISReportsCount > 0 && (
    //                                 <Grid
    //                                     className='my-2'
    //                                     style={{
    //                                         display: "flex",
    //                                         justifyContent: "space-between",
    //                                         padding: 10,
    //                                     }}
    //                                 >
    //                                     <Grid
    //                                         style={{
    //                                             marginTop: "15px",
    //                                         }}
    //                                     >
    //                                         Total Campaigns: {state.billingMISReportsCount}
    //                                     </Grid>

    //                                     <TablePaginationShowPage
    //                                         rowsPerPageOptions={[5, 10, 25, 100, 500, 1000]}
    //                                         colSpan={3}
    //                                         count={state.billingMISReportsCount}
    //                                         rowsPerPage={pageSize}
    //                                         page={currentPage}
    //                                         slotProps={{
    //                                             select: {
    //                                                 "aria-label": "Rows per page",
    //                                             },
    //                                             actions: {
    //                                                 showFirstButton: true,
    //                                                 showLastButton: true,
    //                                                 slots: {
    //                                                     firstPageIcon: FirstPageRoundedIcon,
    //                                                     lastPageIcon: LastPageRoundedIcon,
    //                                                     nextPageIcon: ChevronRightRoundedIcon,
    //                                                     backPageIcon: ChevronLeftRoundedIcon,
    //                                                 },
    //                                             },
    //                                         }}
    //                                         onPageChange={handleChangePage}
    //                                         onRowsPerPageChange={handleChangeRowsPerPage}
    //                                     />
    //                                     <AlertMessageComponent
    //                                         message={errorResponse}
    //                                         fieldName={"ErrorMessage"}
    //                                         handleClose={() => setErrorResponse("")}
    //                                         show={Boolean(errorResponse)}
    //                                     />
    //                                 </Grid>
    //                             )}
    //                         </>
    //                     </>
    //                 )}
    //                 {updateReport.openModel && (
    //                     <UpdateMISReportsComponent
    //                         open={updateReport.openModel}
    //                         handleClose={handleCloseUpdateReport}
    //                         setUpdateDates={setUpdateReport}
    //                         updateDates={updateReport}
    //                         handleClear={handleClearUpdateReport}
    //                         handleUpdate={handleUpdate}
    //                         loading={state.updateBillingMISReportsLoading}
    //                         error={state.updateBillingMISReportsError}
    //                         success={state.updateBillingMISReports}
    //                     />
    //                 )}
    //                 {state.getCampaignMISReportsError && (
    //                     <AlertMessageComponent
    //                         message={state.getCampaignMISReportsError}
    //                         fieldName={"getCampaignMISReportsError"}
    //                         handleClose={onCloseErrorMessage}
    //                         show={Boolean(state.getCampaignMISReportsError)}
    //                     />
    //                 )}
    //             </CardContent>
    //         </Card>
    //     </Grid>
    // );
};

export default BillingMIS;
